import { render, staticRenderFns } from "./ReviewVot.vue?vue&type=template&id=47f5b94c&scoped=true"
import script from "./ReviewVot.vue?vue&type=script&lang=js"
export * from "./ReviewVot.vue?vue&type=script&lang=js"
import style0 from "./ReviewVot.vue?vue&type=style&index=0&id=47f5b94c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f5b94c",
  null
  
)

export default component.exports